import { render } from "./Social.vue?vue&type=template&id=a6e79e4c&scoped=true&ts=true"
import script from "./Social.vue?vue&type=script&lang=ts"
export * from "./Social.vue?vue&type=script&lang=ts"

import "./Social.vue?vue&type=style&index=0&id=a6e79e4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e79e4c"]])

export default __exports__